<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn @click="onClose" ripple icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-layout wrap>
        <v-flex xs12 sm12>
          <h1>{{ action == 'add' ? 'Add Branch' : 'Edit Branch' }}</h1>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('Brand') }">
            <label for="Brand" class="caption">
              {{ $t('Brand') }} <span class="red--text">*</span>
            </label>
            <!-- @input="onSelectedBrand" -->
            <multiselect
              ref="Brand"
              name="Brand"
              :data-vv-as="$t('Brand')"
              v-validate="'required'"
              v-model="input.brand"
              :options="brandOptions"
              selectLabel
              selectedLabel
              :allow-empty="false"
              deselect-label
              :searchable="false"
              open-direction="bottom"
            ></multiselect>
            <span class="text-error" v-show="errors.has('Brand')">
              {{ errors.first('Brand') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('Branch') }">
            <label for="Branch" class="caption">
              {{ $t('Branch') }} <span class="red--text">*</span>
            </label>
            <input
              :data-vv-as="$t('Branch')"
              v-validate="'required'"
              name="Branch"
              v-model="input.branch"
              class="form-control"
              type="text"
            />
            <!-- <multiselect
              ref="Branch"
              name="Branch"
              :data-vv-as="$t('Branch')"
              v-validate="'required'"
              v-model="input.branch"
              :options="branchOptions"
              selectLabel
              selectedLabel
              :searchable="false"
              open-direction="bottom"
            ></multiselect> -->
            <span class="text-error" v-show="errors.has('Branch')">
              {{ errors.first('Branch') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('Detail') }">
            <div>
              <label for="descriptionInput" class="caption"
                >{{ $t('Detail') }} <span class="red--text">*</span></label
              >
            </div>
            <textarea
              type="text"
              class="form-control"
              id="Detail"
              name="Detail"
              style="resize: vertical; min-height: 90px; width: 100%"
              :data-vv-as="$t('Detail')"
              aria-describedby="description"
              :placeholder="$t('Detail')"
              row="3"
              v-model="input.details"
              v-validate="'required'"
            ></textarea>
            <span class="text-error" v-show="errors.has('Detail')">
              {{ errors.first('Detail') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('phoneNumber') }">
            <div>
              <label for="phoneNumber" class="caption"
                >{{ $t('Phone Number') }} <span class="red--text">*</span></label
              >
            </div>
            <input
              :data-vv-as="$t('Phone Number')"
              v-validate="'required'"
              name="phoneNumber"
              v-model="input.phone_number"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-show="errors.has('phoneNumber')">
              {{ errors.first('phoneNumber') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('refNo') }">
            <div>
              <label for="refNo" class="caption"
                >{{ $t('Ref No.') }} <span class="red--text">*</span></label
              >
            </div>
            <input
              :data-vv-as="$t('Ref No.')"
              v-validate="'required'"
              name="refNo"
              v-model="input.refno"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-show="errors.has('refNo')">
              {{ errors.first('refNo') }}
            </span>
          </div>
        </v-flex>

        <v-flex xs12 xm12 class="text-xs-center">
          <v-btn @click="onClose" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="onSave" depressed color="primary">save</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  props: ['value', 'location', 'action'],
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        brand: '',
        branch: '',
        details: '', // รายละเอียดสาขา
        phone_number: '',
        refno: '' // รหัสสาขา
      },
      brandOptions: ['GRAM Pancakes', 'PABLO Cheese Tart', 'KOF'],
      branchOptions: [],
      saveloading: false,
      branchId: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    // onSelectedBrand(val) {
    //   let allBranchs = this.location;
    //   const branchOptions = allBranchs.filter(el => el.brand == val).map(obj => obj.branch);
    //   this.branchOptions = branchOptions;
    // },
    async onSave() {
      if (await this.$validator.validate()) {
        var data = {
          pageid: this.selectedBot.pageid,
          brand: this.input.brand,
          branch: this.input.branch,
          details: this.input.details,
          phone_number: this.input.phone_number,
          refno: this.input.refno
        }

        if (this.action == 'add') {
          api.postGPKlocation(data, async (err, response) => {
            if (err) {
              console.log(err)
              return
            }

            if (response && response.responsecode == 200) {
              this.$emit('success')
              this.onClose()
            }
          })
        } else if (this.action == 'edit') {
          let id = this.branchId
          Object.assign(data, { id: id })

          api.putGPKlocation(data, async (err, response) => {
            if (err) {
              console.log(err)
              return
            }

            if (response && response.responsecode == 200) {
              this.$emit('success')
              this.onClose()
            }
          })
        }
      }
    },
    onClose() {
      this.input = {
        brand: '',
        branch: '',
        details: '', // รายละเอียดสาขา
        phone_number: '',
        refno: '' // รหัสสาขา
      }
      this.branchId = null

      this.$emit('close')
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          this.input = newVal
          this.branchId = newVal.id
          // this.onSelectedBrand(newVal.brand)
          // console.log("newVal: ",newVal)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/BranchModal.vue